export default {
  login: {},
  auth: {
    token: null,
    isAuthenticated: false,
    isAuthenticating: false,
    statusText: null,
    username: null
  },
  user: {},
  runs: [],
  run: {
    allocations: {}
  },
  courses: [],
  course: {},
  conflicts: {
    count: 0
  },
  requirements: {
    count: 0
  },
  profile: {
    deans: []
  },
  crosslist: [],
  students: [],
  student: {
    id: '',
    user: {
      email: ''
    },
    locks: [],
    conflicts: [],
    requirements: [],
    restrictions: {
      run_locks: [],
      run_conflicts: [],
      run_requirements: [],
      group_locks: [],
      group_conflicts: [],
      group_requirements: []
    },
    overrides: {},
    courses: [],
    preferences: [],
    links: [],
    topks: [],
    courses_preference: []
  },
  groups: [],
  group: {
    locks: [],
    conflicts: [],
    requirements: [],
    memberships: []
  },
  groupLocks: [],
  school: {},
  assignments: [],
  waitlist: {
    isFetched: false,
    data: []
  }
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js